var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language",on:{"click":function($event){return _vm.$emit('select-language')}}},[_c('h3',[_vm._v(_vm._s(_vm.nativeLanguageName(_vm.language)))])])}
var staticRenderFns = []

export { render, staticRenderFns }